(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function OEComparisonTool(elem) {
        Behaviors.init(OEComparisonTool, this, arguments);

        var $thisElem = this.$elem,
            body = $('body'),
            postType = $thisElem.data('post-type'),
            products = $thisElem.find('.OEProductsComparisonTool-products');

        // ===============================
        // Save or load compared products (per postType)
        // ===============================
        function getProductsList(save = true) {
            const models = [];

            $('.OEProductsComparisonTool-products-product').each(function () {
                const model = $(this).find('.OEProductsComparisonTool-products-product-model').text().trim();
                if (model) models.push(model);
            });

            if (save) {
                const key = 'comparisonProducts_' + postType;
                localStorage.setItem(key, JSON.stringify(models));
                $thisElem.find('.OEProductsComparisonTool-selected_products').val(models);
            }

            return models;
        }

        // ===============================
        // Disable Compare Button Check
        // ===============================
        function disabledProductsCheck() {
            if ($('.oe-compare-button.active').length > 2) {
                $('.oe-compare-button:not(.active)').addClass('disabled');
            } else {
                $('.oe-compare-button').removeClass('disabled');
            }
        }

        // ===============================
        // Add product (AJAX)
        // ===============================
        function addProduct(model, $wrap) {
            return $.ajax({
                url: wpAjaxUrl,
                data: { action: 'comparison_tool', postType: postType, model: model },
                type: 'POST',
                beforeSend: function () {
                    body.addClass('OE--loading');
                },
                success: function (data) {
                    if ($wrap && $wrap.length) {
                        $wrap.append(data).addClass('has-product');
                    }
                },
                complete: function () {
                    body.removeClass('OE--loading');
                }
            });
        }

        // ===============================
        // Add Product (button click)
        // ===============================
        $(document).on('click', '.oe-compare-button', function (e) {
            e.preventDefault();

            var $this = $(this),
                model = $this.data('model');

            if (!$this.hasClass('disabled') && !$this.hasClass('active')) {
                $this.addClass('active');

                // Find first empty wrap
                const $emptyWrap = $('.OEProductsComparisonTool-products-product-wrap')
                    .filter(function () { return $.trim($(this).html()) === ''; })
                    .first();

                addProduct(model, $emptyWrap).done(function () {
                    getProductsList();
                    disabledProductsCheck();
                });
            }

            if ($('.oe-compare-button.active').length > 0) {
                body.addClass('show-comparison-tool');
            } else {
                body.removeClass('show-comparison-tool');
            }
        });

        // ===============================
        // Remove Product
        // ===============================
        $(document).on('click', '.OEProductsComparisonTool-products-product-remove', function () {
            const $this = $(this);
            const $product = $this.closest('.OEProductsComparisonTool-products-product');
            const model = $product.data('model');
            const $wrap = $this.closest('.OEProductsComparisonTool-products-product-wrap');
            const $container = $('.OEProductsComparisonTool-products');

            $product.remove();
            $wrap.removeClass('has-product');

            $('.oe-compare-button[data-model="' + model + '"]').removeClass('active');

            getProductsList();
            disabledProductsCheck();

            if ($container.find('.OEProductsComparisonTool-products-product-wrap.has-product').length < 1) {
                body.removeClass('show-comparison-tool');
            }

            const $filled = $container.find('.OEProductsComparisonTool-products-product-wrap.has-product');
            const $empty = $container.find('.OEProductsComparisonTool-products-product-wrap').not('.has-product');
            $container.append($filled).append($empty);
        });

        // ===============================
        // Cancel Comparison Tool
        // ===============================
        $thisElem.find('.OEProductsComparisonTool-cancel').on('click', function (e) {
            e.preventDefault();

            $thisElem.find('.OEProductsComparisonTool-products').empty();
            $('.oe-compare-button').removeClass('active');
            localStorage.removeItem('comparisonProducts_' + postType);

            disabledProductsCheck();
            body.removeClass('show-comparison-tool');
        });

        // ===============================
        // Restore Products from localStorage (per postType)
        // ===============================
        const key = 'comparisonProducts_' + postType;
        const storedModels = JSON.parse(localStorage.getItem(key) || '[]');

        if (storedModels.length) {
            let emptyWraps = $('.OEProductsComparisonTool-products-product-wrap').toArray();
            let ajaxPromises = [];

            storedModels.forEach((model) => {
                if (emptyWraps.length === 0) return;
                const $wrap = $(emptyWraps.shift());
                const ajaxPromise = addProduct(model, $wrap).done(function () {
                    $('.oe-compare-button[data-model="' + model + '"]').addClass('active');
                });
                ajaxPromises.push(ajaxPromise);
            });

            $.when.apply($, ajaxPromises).done(function () {
                body.addClass('show-comparison-tool');
                getProductsList();
                disabledProductsCheck();
            });
        }
    }

    Behaviors.inherit(OEComparisonTool, Behaviors.Behavior);
    OEComparisonTool.QUERY = "[data-oe-comparison-tool]";
    Behaviors.register_behavior(OEComparisonTool);
    module.OEComparisonTool = OEComparisonTool;

    return module;

}(window.jQuery, window.Behaviors));